var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.148438C5.34375 0.148438 0 4.55469 0 9.89844C0 12.2422 0.984375 14.3516 2.67188 16.0391C2.0625 18.4297 0.09375 20.4922 0.09375 20.5391C0 20.6328 -0.046875 20.8203 0 20.9609C0.09375 21.1016 0.1875 21.1484 0.375 21.1484C3.46875 21.1484 5.8125 19.6953 6.9375 18.7578C8.48438 19.3203 10.1719 19.6484 12 19.6484C18.6094 19.6484 24 15.2891 24 9.89844C24 4.55469 18.6094 0.148438 12 0.148438ZM6 11.3984C5.15625 11.3984 4.5 10.7422 4.5 9.89844C4.5 9.10156 5.15625 8.39844 6 8.39844C6.79688 8.39844 7.5 9.10156 7.5 9.89844C7.5 10.7422 6.79688 11.3984 6 11.3984ZM12 11.3984C11.1562 11.3984 10.5 10.7422 10.5 9.89844C10.5 9.10156 11.1562 8.39844 12 8.39844C12.7969 8.39844 13.5 9.10156 13.5 9.89844C13.5 10.7422 12.7969 11.3984 12 11.3984ZM18 11.3984C17.1562 11.3984 16.5 10.7422 16.5 9.89844C16.5 9.10156 17.1562 8.39844 18 8.39844C18.7969 8.39844 19.5 9.10156 19.5 9.89844C19.5 10.7422 18.7969 11.3984 18 11.3984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextIcon);
export default __webpack_public_path__ + "static/media/text_icon.d56eec78ba629bb23acf31a0df649073.svg";
export { ForwardRef as ReactComponent };